import type Phaser from 'phaser';
import { getVolume, setVolume } from '@/storage/settings-repository';

/**
 * Centralized audio manager that bridges the settings repository
 * with Phaser's sound system. All volume changes flow through here
 * to ensure the game's global volume stays in sync with LocalStorage.
 */

let gameInstance: Phaser.Game | null = null;

export function initAudio(game: Phaser.Game): void {
  gameInstance = game;
  applyStoredVolume();
}

export function applyStoredVolume(): void {
  if (!gameInstance) {
    return;
  }
  const volume = getVolume();
  gameInstance.sound.volume = volume;
}

export function setGameVolume(volume: number): void {
  const clamped = Math.max(0, Math.min(1, volume));
  setVolume(clamped);
  if (gameInstance) {
    gameInstance.sound.volume = clamped;
  }
}

export function getGameVolume(): number {
  return getVolume();
}

export function getGameInstance(): Phaser.Game | null {
  return gameInstance;
}
